var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"title"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.surveyQuestion.longCaption)}})]),_c('sanitas-button',{attrs:{"primary":""},on:{"click":_vm.handleClose}},[_vm._v(" "+_vm._s(_vm.texts.close)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }